import { useState, useEffect, useRef } from 'react';

const useIsSticky = () => {
  const [isSticky, setIsSticky] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        setIsSticky(rect.top <= 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check in case element is already at the top

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { ref, isSticky };
};

export default useIsSticky;
